import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPlaceholder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 48 48",
	fill: "none",
	role: "img",
	focusable: "false",
	"aria-hidden": "true",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8972_161216)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 48,
				height: 48,
				fill: "#ededed"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 0L24 48",
				stroke: "#d7d7d7",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33 0L33 48",
				stroke: "#d7d7d7",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15 0L15 48",
				stroke: "#d7d7d7",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 24H48",
				stroke: "#d7d7d7",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 33H48",
				stroke: "#d7d7d7",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 15H48",
				stroke: "#d7d7d7",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48 0L1.78814e-07 48",
				stroke: "#d7d7d7",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0L48 48",
				stroke: "#d7d7d7",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 24,
				cy: 24,
				r: 18,
				stroke: "#d7d7d7",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 24,
				cy: 24,
				r: 13,
				stroke: "#d7d7d7",
				strokeWidth: .5
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8972_161216",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			fill: "white"
		})
	}) })]
});
export { SvgIconPlaceholder as ReactComponent };
